import React, { useEffect } from "react";
import TablePagination from "../../../../../common/components/Pagination";

export const StimTablePaginationBlock = ({ paginationState, onPageChange, onRowsPerPageChange }) => {

    const { result_count, results_per_page, total_page_num, page_num } = paginationState
    const numberOfPages = Math.ceil(result_count / results_per_page);
    return (
        <TablePagination
            numberOfPages={numberOfPages}
            currentPage={page_num}
            rowsPerPage={results_per_page}
            onPageChange={(e, newPage) => (console.log('mango', e, newPage), onPageChange(newPage))}
            onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
        />
    );
};

